import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  BrowserRouter,
  Redirect,
  Route,
  Switch,
  useLocation,
} from "react-router-dom";
import HomePage from "../Pages/Home";
import AboutUs from "../Pages/AboutUs";
import GramSchemes from "../Pages/GramSchemes";
import FormsPage from "../Pages/Forms/index";
import GalleryPage from "../Pages/Gallery/index";
import ContactUs from "../Pages/Contactus";
import Suggetions from "../Pages/Suggetions";
import GramHome from "../Pages/GramHome";
import ModalContainer from "../ModalLayouts/ModalContainer";
import GetPageData from "../hooks/GetPageData";
import NavAndFooter from "../Pages/Common/NavAndFooterContainer/";
import LoadingComponet from "../components/Loading/LoadingComponet";
import TermsPage from "../Pages/TermsAndConditions";
import Div100vh from "react-div-100vh";
import AchievemntPage from "../Pages/AchievementPage";
import Comingsoon from "./ComingSoon";
import { Helmet } from "react-helmet";
import CopyRights from "../Pages/CopyRights";
import ReactGA from "react-ga";
const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      backgroundColor: "white",
    },
  },
}));

const HomeRoutes = () => {
  const classes = useStyles();
  const { ready, data, error } = GetPageData("navbar");

  const ScrollToTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    return null;
  };
  const location = useLocation();
  // console.log("location", location.pathname);
  ReactGA.pageview(location.pathname);
  return ready && data ? (
    // <Div100vh>
    <>
      <Helmet>
        <title>Egram Panchayat</title>
        <meta name="description" content="Welcome to e-gram panchayat" />

        <meta property="og:title" content="Egram panchayat" />
        <meta property="og:url" content="https://egrampanchayat.in" />
        <meta property="og:description" content="Egram panchayat website" />
        <meta
          property="og:image"
          itemprop="image"
          content="https://egrampanchayat.in/images/otherlogos/selfmade.png"
        />
        <meta
          property="og:image:secure_url"
          itemprop="image"
          content="https://egrampanchayat.in/images/otherlogos/selfmade.png"
        />
        <meta
          property="og:image:secure_url"
          itemprop="image"
          content="https://egrampanchayat.in/images/otherlogos/selfmade.png"
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_IN" />
      </Helmet>
      <NavAndFooter data={data}>
        <Route component={ScrollToTop} />

        <Route exact path="/" component={HomePage} />

        <Route exact path="/aboutus" component={AboutUs} />
        <Route
          exact
          path="/gramschemes/:schemeCategory?"
          component={GramSchemes}
        />
        <Route exact path="/forms" component={FormsPage} />
        <Route exact path="/gallery" component={GalleryPage} />
        <Switch>
          <Route exact path="/achievement/:id" component={AchievemntPage} />
        </Switch>

        <Route exact path="/termsandconditions" component={TermsPage} />
        <Route exact path="/copyrights" component={CopyRights} />
        <ModalContainer />
      </NavAndFooter>
    </>
  ) : (
    // </Div100vh>
    <div>
      <LoadingComponet />
    </div>
  );
};
export default HomeRoutes;
